import React from 'react';
import type { GamificationConfig, GamificationEventsSummary } from '@troia-v3/types';

import { ActivationSection } from './ActivationSection';
import { CelebrationSection } from './CelebrationSection';
import { LevelsEditor } from './LevelsEditor';
import { PointsRulesTable } from './PointsRulesTable';
import { RankingSection } from './RankingSection';

export type ConfigDraft = Pick<GamificationConfig, 'enabled' | 'rules' | 'levels' | 'period' | 'rankings' | 'visibility' | 'celebrate'>;

interface Props { draft: ConfigDraft; onChange: (patch: Partial<ConfigDraft>) => void; summary?: GamificationEventsSummary; disabled?: boolean }

/**
 * Aba "Configuração" — as 5 seções na ordem Ativação → Tabela de pontos →
 * Níveis → Ranking → Celebração, cada uma num Card com os campos um abaixo do
 * outro, no padrão do formulário de edição de canal (`EditChannelPage`:
 * container `max-w-screen-2xl` + `space-y-6` de Cards). `disabled` (repassado
 * da página, `!canUpdate`) desliga todo controle das 5 seções.
 */
export const ConfigTab: React.FC<Props> = ({ draft, onChange, summary, disabled = false }) => (
  <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 md:px-8 py-6 space-y-6" data-testid="gamification-config-tab">
    <ActivationSection enabled={draft.enabled} onChange={(enabled) => onChange({ enabled })} period={draft.period} disabled={disabled} {...(summary ? { summary } : {})} />
    <PointsRulesTable rules={draft.rules} onChange={(rules) => onChange({ rules })} disabled={disabled} />
    <LevelsEditor levels={draft.levels} onChange={(levels) => onChange({ levels })} disabled={disabled} />
    <RankingSection period={draft.period} rankings={draft.rankings} visibility={draft.visibility} onChange={onChange} disabled={disabled} />
    <CelebrationSection value={draft.celebrate} onChange={(celebrate) => onChange({ celebrate })} disabled={disabled} />
  </div>
);
ConfigTab.displayName = 'ConfigTab';
